<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-drawer :visible.sync="drawerVisible"
    :append-to-body="true"
    class="todo-drawer"
    :title="title"
    :before-close="handleClose">
    <div slot="title" class="title">
      <div class="left">
        <span>我的待办</span>
      </div>
      <div class="right">
        <el-button type="text" @click="refreshHandle">刷新</el-button>
      </div>
    </div>

    <!-- source: -1 首页 0 未处理 1 已处理 -->
    <todo-list v-if="dataList.length > 0" :dataList="dataList" @closeDialog="handleClose" source="-1" />

    <div v-else class="no-todo mt16">暂无待办任务，可前往
        <el-button @click="goBackLogCenterHandle" type="text">
          待办中心
        </el-button>
        查看更多
    </div>

    <div class="drawer-bottom">
      <el-button type="text" @click="goBackLogCenterHandle">进入待办中心 &gt;</el-button>
    </div>
  </el-drawer>
</template>

<script>
import todoList from './todoList.vue'
import { getIndexTodoList } from '@/api/todoApi'

export default {
  components: {
    todoList,
  },
  props: {
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '我的待办',
    },
  },
  watch: {
    // drawerVisible (val) {
    //   this.visible = val
    //   this.dataList = []
    //   if (val) {
    //     this.getIndexTodoList()
    //   }
    // }
  },
  data() {
    return {
      // visible: false,
      dataList: [],
    }
  },
  created() {
    this.getIndexTodoList()
  },
  methods: {
    refreshHandle() {
      this.getIndexTodoList()
    },
    // 获取首页待办列表
    async getIndexTodoList() {
      const { code, data } = await getIndexTodoList()
      if (code === 1) {
        this.dataList = data || []
      }
    },
    // 去待办中心
    goBackLogCenterHandle() {
      this.handleClose()
      this.$router.push('/workbench/todo')
    },
    handleClose() {
      // this.dataList = []
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
  }
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
      color: #3D3D3D;
    }
  }
}
.no-todo {
  display: flex;
  justify-content: center;
}

.drawer-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 16px;
  display: flex;
  justify-content: flex-end;
  padding: 32px 28px;
}
</style>
